module.exports = __webpack_public_path__ + "static/img/xiangjiao.2c12931f.png";